import { ORDER_PHASE_DELIVERING } from '../../constants';
import { getOrdersWithStatus } from '../../utils/orderUtils';

export const getPins = (props, component) => {
  const { orders, locationShop, driversRealTime } = props;
  const { lat, lng } = locationShop;
  const ordersPhaseDelivering = getOrdersWithStatus(orders, ORDER_PHASE_DELIVERING);
  component.setState({ orders, ordersPhaseDelivering, drivers: driversRealTime });
  if (lng !== 'undefined' && lat !== 'undefined' && lat && lng) {
    component.setState({ center: locationShop });
  }
};
